// @flow

import * as React from 'react';
import Icon from 'sail/Icon';
import Box from 'sail/Box';
import type {IconType} from 'sail/Icon/types';
import classNames from 'classnames';
import './XRayOverlayContainer.scss';

type XRayOverlayContainerProps = {|
  icon?: ?IconType,
  title?: React.Node,
  color?: string,
  actions?: React.Node,
  className?: string,
  children: React.Node,
|};

export const XRayOverlayContainer = ({
  icon,
  title,
  color,
  actions,
  className,
  children,
}: XRayOverlayContainerProps) => {
  return (
    <Box
      className={classNames(
        'XRayOverlayContainer',
        `XRayOverlayContainer--${color ?? 'blue'}`,
        className,
      )}
    >
      <div className="XRayOverlayContainer-title">
        {icon && (
          <Icon
            size={12}
            icon={icon}
            color="white"
            className="XRayOverlayContainer-title-icon"
          />
        )}
        {title}
      </div>
      {actions && <div className="XRayOverlayContainer-actions">{actions}</div>}
      <div className="XRayOverlayContainer-content">{children}</div>
    </Box>
  );
};
